import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler } from '..'

export class GlobalCopyApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getGlobalCopy = async (namespace: string, translationKey: string) => {
    return this.fetchInstance
      .post(`${ApiEndpoints.LOCALIZED_CONTENT}/${namespace}`, { translation_key: translationKey })
      .then((data) => data)
  }
}
